module.exports = __webpack_public_path__ + "media/images/bnr_special_local-2e21052d8ea754023ff38c9d0c93bd20.jpg";